import { GET_ADDTAG_FAILED, GET_ADDTAG_REQUESTED, GET_ADDTAG_SUCCESS, GET_RATING_FAILED, GET_RATING_REQUESTED, GET_RATING_SUCCESS, GET_TAG_FAILED, GET_TAG_REQUESTED, GET_TAG_SUCCESS, GET_UPDATETAG_FAILED, GET_UPDATETAG_REQUESTED, GET_UPDATETAG_SUCCESS } from "resources/actionTypes";


const initialState = {
  userTag: [],
  loading: false,
  error: null,
};
const initialStateAdd = {
  userAddTag: [],
  loading: false,
  error: null,
};
const initialStateRating = {
  userRating: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateTag: [],
  loading: false,
  error: null,
}

export function userTag(state = initialState, action) {
  switch (action.type) {
    case GET_TAG_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        userTag: action.userTag,
      };
    case GET_TAG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddTag(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDTAG_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddTag: action.userAddTag,
      };
    case GET_ADDTAG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateTag(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATETAG_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATETAG_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateTag: action.userUpdateTag,
      };
    case GET_UPDATETAG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRating(state = initialStateRating, action) {
  switch (action.type) {
    case GET_RATING_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RATING_SUCCESS:
      return {
        ...state,
        loading: false,
        userRating: action.userRating,
      };
    case GET_RATING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}